const organiseGreenhouseEvents = (greenhouseData, prismicData) => {
  let events = [];

  greenhouseData.nodes.forEach(node => {
    // eslint-disable-next-line
    prismicData.nodes.filter(event => {
      if (parseInt(event.uid) === node.gh_Id) {
        let cover = event.data.thumbnail;

        events.push({
          id: node.gh_Id,
          title: node.title,
          link: `/event/${node.slug}`,
          metadata: {
            secondary: node.location.name,
            primary: event.data.start_date
          },
          image: {
            desktop: cover.url,
            mobile: cover.mobile.url
          },
          summary: event.data.summary.text
        });
      }
    });
  });

  return events;
};

export { organiseGreenhouseEvents };
